﻿import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
	selector: 'form-case-hand-over-investor',
	templateUrl: './form-case-hand-over-investor.component.html',
	styleUrls: ['./form-case-hand-over-investor.component.scss']
})
export class FormCaseHandOverInvestorComponent implements OnInit {

  @Output()
  callbackRegister = new EventEmitter();
  @Input()
  data: any;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    this.data.handedOverInvestorDate = this.data.handedOverInvestorDate || new Date();

    this.callbackRegister.emit({
      isValid: this.isValid,
    });
  }

  isValid() {
    return !!this.data.handedOverInvestorDate;
  }
}
